import hsv_rgb from './hsv-rgb'

export default `${hsv_rgb}
uniform vec3 uBaseColor;
uniform vec4 uRectData;
uniform vec3 uColor1;
uniform vec3 uColor2;
uniform vec3 uColor3;
uniform vec3 uColor4;
uniform vec3 uLightDirection;

varying vec2 vUv;
varying vec3 vNormal;
varying vec3 vNormal2;
varying vec3 vPosition;

float getFresnel(vec3 normal, float power) {
  vec3 viewDir = vec3(0.0, -0.5, 1.0);
  return 1.0 - pow(max(dot(viewDir, normal), 0.0), power);
}

vec3 highlightDirection = normalize(vec3(0.0, 1.0, 0.6));

void main(){
  vec3 color = vNormal2 * 0.5 + 0.5;
  color = uBaseColor;

  float fresnel = 1.0 - getFresnel(vNormal, 4.0);
  fresnel *= 0.5;

  float r = vUv.y;

  float cheak = smoothstep(0.2, 0.0, length(abs(vUv - vec2(0.5, 0.0)) - vec2(0.24, 0.7)));

  color = mix(uColor1, uColor2, smoothstep(0.1, 0.5, r));
  color = mix(color, uColor3, smoothstep(0.5, 1.0, r));
  color = mix(color, uColor4, cheak);

  float light = max(0.0, dot(normalize(uLightDirection), vNormal2));
  float highlight = max(0.0, dot(highlightDirection, vNormal2));
  highlight = pow(highlight, 10.0);

  vec3 hsv = rgb2hsv(color);
  hsv.g += mix(0.05, 0.0, light) + highlight * 0.1;
  hsv.b += mix(-0.1, 0.1, light) + highlight;
  color = hsv2rgb(hsv);

  color = pow(color, vec3(1.0/2.2));
  gl_FragColor = vec4(color, 1.0);
}
`
